var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcCredoScore = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_credit_score",
  "data-name": "ic_credit score",
  transform: "translate(-348.997 12332.062)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2",
  "data-name": "Rectangle 2",
  width: 34,
  height: 34,
  transform: "translate(348.997 -12332.062)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "CS3",
  transform: "translate(352 -12326.059)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M20.546,13.465c1.9,2.7,2.061,5.738,1.868,8.887H.072c-.012-.014-.045-.038-.046-.061-.072-2.481-.095-4.944.994-7.281A11.272,11.272,0,0,1,13.579,8.724c.158.034.316.064.54.11a6.715,6.715,0,0,1,1.412-6.62A6.427,6.427,0,0,1,19.9.024a6.756,6.756,0,0,1,7.226,5.618,6.837,6.837,0,0,1-6.584,7.822ZM1.757,19.321v.736L.78,20.1c0,.366.025.695-.006,1.018-.039.4.081.533.509.532q9.933-.021,19.865-.01h.506V20.108l-.944-.055v-.731h.959a10.17,10.17,0,0,0-1.193-4.5L19.6,15.3c-.123-.223-.235-.426-.357-.645l.833-.523a10.078,10.078,0,0,0-3.279-3.271l-.525.836-.627-.362c.157-.306.3-.588.456-.892a10.155,10.155,0,0,0-4.46-1.178c-.017.35-.032.654-.047.951h-.766V9.264a9.969,9.969,0,0,0-4.482,1.195l.473.871-.636.368-.509-.813a8.758,8.758,0,0,0-3.243,3.282l.8.491-.388.631-.835-.459A8.4,8.4,0,0,0,.871,19.319h.883Zm24.676-12.6A5.93,5.93,0,1,0,14.955,8.8a.939.939,0,0,0,.458.473A11.8,11.8,0,0,1,19.764,12.4a.708.708,0,0,0,.439.221,5.908,5.908,0,0,0,6.227-5.9Z",
  transform: "translate(0 0)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M54.936,138.917c-1.3,1.161-2.566,2.31-3.851,3.443a.652.652,0,0,0-.266.755,1.4,1.4,0,0,1-.811,1.583,1.468,1.468,0,0,1-1.84-2.157,1.421,1.421,0,0,1,1.692-.55.54.54,0,0,0,.664-.133c.977-.9,1.972-1.776,2.962-2.66.109-.1.229-.184.4-.318a6.5,6.5,0,0,0-6.1-1.506c-3.254.877-4.882,3.157-5.178,6.481H41.96c-.449-2.345,1.685-5.635,4.451-6.84a7.4,7.4,0,0,1,8.526,1.9Zm-5.577,3.744a.691.691,0,0,0-.672.739.7.7,0,0,0,1.393-.043.7.7,0,0,0-.72-.7Z",
  transform: "translate(-38.153 -124.192)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "_",
  "data-name": "$",
  d: "M3.2-3.791a.846.846,0,0,0-.237-.616,2.067,2.067,0,0,0-.788-.438A6.2,6.2,0,0,1,1.321-5.2,1.745,1.745,0,0,1,.3-6.825a1.671,1.671,0,0,1,.442-1.2,1.884,1.884,0,0,1,1.2-.556v-.955h.7v.963a1.734,1.734,0,0,1,1.177.642,2.212,2.212,0,0,1,.416,1.392H3.173a1.38,1.38,0,0,0-.247-.869.807.807,0,0,0-.672-.321.908.908,0,0,0-.654.239.864.864,0,0,0-.237.652.817.817,0,0,0,.234.611,2.279,2.279,0,0,0,.794.436,6.717,6.717,0,0,1,.88.381,2.248,2.248,0,0,1,.535.4,1.592,1.592,0,0,1,.34.517,1.832,1.832,0,0,1,.118.687,1.636,1.636,0,0,1-.45,1.2,1.994,1.994,0,0,1-1.263.543V-1.2h-.7v-.85A2,2,0,0,1,.52-2.671,2.02,2.02,0,0,1,.054-4.063H1.118a1.215,1.215,0,0,0,.278.856,1.015,1.015,0,0,0,.786.3,1.081,1.081,0,0,0,.76-.241.829.829,0,0,0,.26-.645Z",
  transform: "translate(18.368 11.725)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcCredoScore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_credo_score.4ada2ac4a9c748e65240973ea47c3508.svg";